import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./AscensionGameEntrance.module.css";
function AscensionGameEntrance() {
  useEffect(() => {
    localStorage.setItem(
      "selectedEventName",
      window.location.href.split("//")[1].split("/")[1]
    );

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}projects/getprojectbypath`, {
        path: window.location.href,
      })
      .then((res) => {
        if (res.data._id !== undefined) {
          axios
            .post(
              `${process.env.REACT_APP_SERVER_URL}stats/setpage/GameEntrance`,
              {
                id: res.data._id,
              }
            )
            .then((res) => {});
        }
      });
  }, []);
  let history = useNavigate();
  return (
    <div>
      <div className={styles["mentor-card-screen-background"]}>
        <div className='col-md-12 col-xs-12'>
          <div className='row'>
            <div
              className={styles["btn-back-envirtual-container"] + " col-md-12"}
              onClick={() => {
                history("/asc3/breakroom");
              }}
            >
              <img src='/assets/back-btn.svg' className={styles["ddl"]}></img>
              <label className={styles["back-btn-label"]}>Back</label>
            </div>
          </div>
          <div className='row'>
            <div className={styles["main-div"] + " col-md-6 col-xs-12"}>
              <span className={styles["header-text"]}>game room</span>
              <span className={styles["description-text"] + " mt-4"}>
                Are you ready for some brain-tickling fun?
              </span>
              <div
                style={{ display: "flex", flexDirection: "row" }}
                className='mt-4'
              >
                <button
                  className={styles["btn-styling"]}
                  onClick={() => {
                    history("/asc3/game");
                  }}
                >
                  Discover Game Room
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AscensionGameEntrance;
